export const ADDEDTOCART = 'cart/added';
export const DECREASEFROMCART = 'cart/decrease';
export const INCREASEFROMCART = 'cart/increase';
export const REMOVECART = 'cart/remove';
